import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"

const ScrollCard = ({ title, richContent, items }) => {
  return (
    <section className="scroll-card">
      <div className="scroll-card__inner">
        <div
          className="scroll-card__title"
          data-sal="slide-up"
          data-sal-duration="1000"
          data-sal-easing="ease"
        >
          {title && <h2>{parse(title)}</h2>}
          {richContent && <StructuredText data={richContent} />}
        </div>

        {items?.length > 0 && (
          <div className="scroll-card__items desktop">
            {items.map((item, index) => (
              <article
                className={`scroll-card__item scroll-card__item-${index}`}
                key={index}
              >
                <div className="scroll-card__item-content">
                  {item.subtitle && (
                    <span className="scroll-card__item-subtitle">
                      {item.subtitle}
                    </span>
                  )}
                  {item.title && <h3>{parse(item.title)}</h3>}
                  {item.caption && (
                    <span className="scroll-card__item-caption">
                      {item.caption}
                    </span>
                  )}
                  {item.richContent && (
                    <StructuredText data={item.richContent} />
                  )}
                </div>

                {item.image && (
                  <div className="scroll-card__item-image">
                    <Asset asset={item.image} />
                  </div>
                )}
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default ScrollCard

export const query = graphql`
  fragment ScrollCardProps on DatoCmsScrollCard {
    ... on DatoCmsScrollCard {
      id
      title
      richContent {
        value
      }
      items {
        subtitle
        title
        caption
        richContent {
          value
        }
        image {
          ...InternalAssetProps
        }
      }
    }
  }
`
